import { render, staticRenderFns } from "./OmzP.vue?vue&type=template&id=5d63894f"
import script from "./OmzP.vue?vue&type=script&lang=js"
export * from "./OmzP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports